<ng-template #contextMenu let-item>
    <div class="dropdown">
        <ul class="dropdown-menu show">
            <li *ngFor="let option of contextMenuOptions" (click)="onOptionClicked($event, option, item)"
                [visible]="option.isVisible" [divider]="option.divider" [enabled]="option.enabled"
                [ngClass]="[option.divider ? 'disabled divider dropdown-divider' : 'menuItem']"
                [attr.title]="option.enabled === true ? '' : option.tooltipFunction && option.tooltipFunction(item) ? option.tooltipFunction(item) : ''"
                [attr.role]="option.divider ? 'separator' : ''">
                <a class="dropdown-item" *ngIf="!option.divider" [ngClass]="[option.enabled ? '' : 'disabled']">
                    <div class="iconContainer">
                        <span class="fa-stack">
                            <i class="iconFirst fa-stack-1x fa {{option.iconClass}} {{option.iconColor}}"
                                [attr.data-automation-id]="option.automationIdFunction(item) + '-icon'">
                            </i>
                            <i *ngIf="option.iconSecondClass"
                                class="iconSecond fa-stack-1x fa {{option.iconSecondClass}} {{option.iconSecondColor}}" [ngClass]="[option.secondIconCustomClass ? 'secondIconCustomClass' : '']"></i>
                        </span>
                    </div>
                    <div class="optionContainer" [attr.data-automation-id]="option.automationIdFunction(item)" [attr.title]="option.tooltip ? option.tooltip : ''">
                        <div class="option-name" >{{option.name || option.nameFunction(item)}}</div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #headerContextMenu let-item>
    <div class="dropdown">
        <ul class="dropdown-menu show">
            <li *ngFor="let option of contextMenuOptions" [visible]="option.isVisible" [divider]="option.divider"
                [enabled]="option.enabled" [passive]="option.passive"
                [ngClass]="[option.divider ? 'disabled divider dropdown-divider' : 'menuItem', option.enabled ? '' : 'disabled']"
                [attr.role]="option.divider ? 'separator' : ''"
                [attr.title]="option.enabled === true ? '' : option.tooltipFunction && option.tooltipFunction(item) ? option.tooltipFunction(item) : ''">
                <span class="dropdown-item"
                    [ngClass]="[option.passive ? 'passive' : '', option.enabled ? '' : 'disabled']">
                    <div (click)="option.click()" class="iconContainer context-menu-header-icon-container">
                        <span class="fa-stack context-menu-header-filter-left-icon">
                            <i *ngIf="option.iconClass"
                                class="iconFirst fa-stack-1x fa {{option.iconClass}} {{option.iconColor}}"></i>
                        </span>
                    </div>
                    <div (click)="option.click()" *ngIf="option.iconClass"
                        class="optionContainer context-menu-header-filter-left-padding"
                        [attr.data-automation-id]="option.automationIdFunction(item)"
                        [attr.title]="option.enabled ? '' : (option.tooltip ? option.tooltip : '')">
                        <div class="option-name context-menu-header-filter" [ngClass]="[option.resetFilterClass ? 'reset-filter' : '']">{{option.name}}</div>
                    </div>
                    <div *ngIf="!option.iconClass" class="context-menu-header-checkbox">
                        <div class="checkboxContainer" [attr.data-automation-id]="option.automationIdFunction(item)">
                            <res-custom-checkbox [automationId]="option.automationIdFunction(item)"
                                [(ngModel)]="option.checked" (ngModelChange)="option.click()" [content]="option.name"
                                [disabled]="!option.enabled" [labelPaddingLeft]="10" [labelPaddingRight]="10">
                            </res-custom-checkbox>
                        </div>
                    </div>
                </span>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #collapsedContextMenu let-item>
    <div class="dropdown"
    [ngClass]="[openMenuOnLeft ? (removeLeftMargin ? 'toggle-box-menu toggle-container-resized no-left-margin' : 'toggle-box-menu toggle-container-resized') : (removeLeftMargin ? 'toggle-box-menu no-left-margin' : 'toggle-box-menu'), isAdvancedSearch ? 'advanced-search-box' : '']">
        <ul class="dropdown-menu show">
            <li class="ng-star-inserted" *ngIf="hasDeselectAll">
                <span [passive]="true" [visible]="true" class="dropdown-item ng-star-inserted">
                    <button class="deselect-all" (click)="deselectAll()">Deselect All</button>
                </span>
            </li>
            <li *ngFor="let option of contextMenuOptions" [passive]="true" [visible]="option.isCollapsed"
                class="ng-star-inserted">
                <span [passive]="true" [visible]="true" class="dropdown-item ng-star-inserted">
                    <res-custom-checkbox [automationId]="'collapsible-toggle-box-group' + option.automationId"
                        [(ngModel)]="option.isChecked" (ngModelChange)="onModelChange(option)" [content]="option.label"
                        [isDisabled]="option.isDisabled" [isToggleBox]="true" [isSkeuomorphic]="isSkeuomorphic"
                        [title]="option.tooltip" [labelPaddingLeft]="labelPaddingLeft"
                        [labelPaddingRight]="labelPaddingLeft">
                    </res-custom-checkbox>
                </span>
            </li>
        </ul>
    </div>
</ng-template>